// core
import React from "react";

// styles
import { IProviderAddon } from "../../../compare/interfaces/IProviderAddon";
import AIAVitalityAddOn from "./AddOn/AIAVitality/AIAVitalityAddOn";
import ChubbLifetimeRewardAddOn from "./AddOn/ChubbLifetimeReward/ChubbLifetimeRewardAddOn";

interface IProviderAddOnProps {
    addOn: IProviderAddon;
    size: "small" | "full";
}

const ProviderAddOn: React.FC<IProviderAddOnProps> = (props) => {
    const { addOn, size } = props;

    switch (addOn.id) {
        case 1:
            return <AIAVitalityAddOn addOn={addOn} size={size} />;
        case 2:
            return <ChubbLifetimeRewardAddOn addOn={addOn} size={size} />;
        default:
            return null;
    }
};

export default React.memo(ProviderAddOn);
